<template>
  <div class="navbar-wrapper">
    <nav class="navbar navbar-default navbar-static-top">
      <div class="container-fluid">
        <!-- Brand and toggle get grouped for better mobile display -->
        <!-- <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1"
            aria-expanded="false">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link to="/admin/dashboard" class="navbar-brand">
            <img src="../../assets/images/mercury-logo-white.png" class="img-responsive">
          </router-link>
        </div> -->

        <!-- Collect the nav links, forms, and other content for toggling -->
        <!-- <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav navbar-right">
            <li><router-link to="/admin/dashboard">Home</router-link></li>
            <li><a href="admin-users.html">Users</a></li>
            <li><a href="#">Data Exporting</a></li>
            <li><a href="dashboard.html">My Account</a></li>
            <li><a v-if="isLoggedIn" @click.prevent="logout">Logout</a></li>
          </ul>
        </div> -->
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters('auth', [
      'isLoggedIn'
    ])
  },
  methods: {
    ...mapActions('auth', {
      storeLogout: 'logout'
    }),
    logout () {
      this.storeLogout()
        .then(() => {
          this.$router.push({ name: 'AdminLogin' })
        })
    }
  }
}
</script>
